import SceneVolumeControl from '@/components/app/scenes/SceneVolumeControl';
import ZenModeSelector from '@/components/app/scenes/ZenModeSelector';

import { Wrapper } from './styles';

const SceneControls = () => {
	return (
		<Wrapper>
			<SceneVolumeControl />
			<ZenModeSelector />
		</Wrapper>
	);
};

export default SceneControls;
